import { useState, useEffect } from "react";
import LayoutHOC from "../LayoutHOC";
import VendorGeneralInfo from "./VendorGeneralInfo";
import VendorSideBar from "./VendorSideBar";
import VendorAddress from "./VendorAddress";
import VendorContact from "./VendorContact";
import VendorFinancialDetails from "./VendorFinancialDetails";
import VendorAttachments from "./VendorAttachments";
import VendorNotes from "./VendorNotes";
import VendorSections from "./VendorSections";
import {
  useGetAddressQuery,
  useGetContactQuery,
  useGetFinancialDetailsQuery,
  useGetVendorByIdQuery,
} from "../../utils/customer/customerTaskTable";
import { getUserToken } from "../../utils/utilityFunctions/localServices";
import { useLocation, useNavigate } from "react-router-dom";

const AddVendor = ({
  handleCloseVendor,
  editData: propEditData,
  isEditVendor,
  setIsEditVendor,
  refetchVendorHeader,
  refetchVendorValues,
  isDisable,
  setIsDisable,
  vendorName,
  setVendorName,
  setSelectedVendorData,
}) => {
  const [activeTab, setActiveTab] = useState("general");
  const [vendorUUID, setVendorUUID] = useState(null);
  const [editSection, setEditSection] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const isViewMode = location.state?.isViewMode ?? true;
  const editData = location.pathname === "/edit-vendor" ? location.state?.vendorData : propEditData;

  console.log(location.state?.vendorData, "89563256235623");

  // Set isDisable based on route
  useEffect(() => {
    setIsDisable(location.pathname === "/add-vendor");
  }, [location.pathname, setIsDisable]);

  console.log(
    "AddVendor editData:",
    editData,
    "isViewMode:",
    isViewMode,
    "pathname:",
    location.pathname,
    "location.state:",
    location.state
  );

  useEffect(() => {
    if (editData && (location.pathname === "/edit-vendor" || isEditVendor)) {
      setVendorName(editData.vendor_name || "");
      setSelectedVendorData(editData);
      setActiveTab(location.state?.activeTab || "general");
      setEditSection(true);
      setIsEditVendor(true);
    } else {
      setVendorName("");
      setSelectedVendorData(null);
      setActiveTab("general");
      setEditSection(false);
      setIsEditVendor(false);
    }
  }, [
    editData,
    isEditVendor,
    setVendorName,
    setSelectedVendorData,
    setIsEditVendor,
    location.pathname,
    location.state,
  ]);

  const {
    data: vendorDetailsResponse,
    isLoading: isVendorLoading,
    isSuccess: isVendorSuccess,
    isError: isVendorError,
    error: vendorError,
    refetch: refetchVendorDetails,
  } = useGetVendorByIdQuery({ UUID: editData?.row_id, token: getUserToken() }, { skip: !editData?.row_id });

  console.log("5151451453415313:", vendorDetailsResponse);

  const {
    data: addressData,
    isLoading: isAddressLoading,
    isSuccess: isAddressSuccess,
    isError: isAddressError,
    error: addressError,
    refetch: refetchAddressData,
  } = useGetAddressQuery({ UUID: editData?.row_id ? editData?.row_id : vendorUUID, token: getUserToken() });

  const {
    data: getContactData,
    isSuccess: isFetched,
    isError: isContactError,
    error: contactError,
    refetch: refetchContactData,
  } = useGetContactQuery({ UUID: editData?.row_id, token: getUserToken() }, { skip: !editData?.row_id });

  const {
    data: getFinancialDetails,
    isSuccess: isFinancialDetailsFetched,
    isError: isFinancialDetailsError,
    error: financialDetailsError,
    refetch: refetchFinancialDetails,
  } = useGetFinancialDetailsQuery({ UUID: editData?.row_id, token: getUserToken() }, { skip: !editData?.row_id });

  // Navigate to VendorProfile with all data
  const handleBackButtonClick = () => {
    handleCloseVendor();
    setActiveTab("general");
    setVendorUUID(null);
    setIsEditVendor(false);
    setVendorName("");
    setEditSection(false);
    navigate("/vendor-profile", {
      // state: {
      //   vendorData: vendorDetailsResponse,
      //   addressData,
      //   contactData: getContactData,
      //   financialDetailsData: getFinancialDetails,
      // },
    });
  };

  const activeVendorComponent = () => {
    switch (activeTab) {
      case "general":
        return (
          <VendorGeneralInfo
            setVendorUUID={setVendorUUID}
            editData={editData}
            handleBackButtonClick={handleBackButtonClick}
            isEditVendor={isEditVendor}
            refetchVendorHeader={refetchVendorHeader}
            refetchVendorValues={refetchVendorValues}
            setIsDisable={setIsDisable}
            vendorName={vendorName}
            setVendorName={setVendorName}
            setSelectedVendorData={setSelectedVendorData}
            editSection={editSection}
            refetchVendorDetails={refetchVendorDetails}
          />
        );
      case "address":
        return (
          <VendorAddress
            vendorUUID={vendorUUID}
            billingAddressData={
              location.state?.addressData || addressData?.data?.find((a) => a.address_type === "billing") || ""
            }
            shippingAddressData={
              location.state?.addressData || addressData?.data?.find((a) => a.address_type === "shipping") || ""
            }
            editData={editData}
            handleBackButtonClick={handleBackButtonClick}
            vendorName={vendorName}
            editSection={editSection}
          />
        );
      case "contact":
        return (
          <VendorContact
            vendorUUID={vendorUUID}
            editData={editData}
            handleBackButtonClick={handleBackButtonClick}
            vendorName={vendorName}
            refetchVendorHeader={refetchVendorHeader}
            refetchVendorValues={refetchVendorValues}
            contactData={location.state?.contactData || getContactData}
          />
        );
      case "financial":
        return (
          <VendorFinancialDetails
            vendorUUID={vendorUUID}
            editData={editData}
            handleBackButtonClick={handleBackButtonClick}
            vendorName={vendorName}
            financialData={location.state?.financialData || getFinancialDetails}
          />
        );
      case "attachments":
        return <VendorAttachments vendorUUID={vendorUUID} />;
      case "notes":
        return <VendorNotes vendorUUID={vendorUUID} />;
      case "addSection":
        return <VendorSections />;
      default:
        return null;
    }
  };

  return (
    <div className="flex flex-col h-full">
      <div className="flex gap-3 min-h-0 grow">
        <div className="min-w-60 border-x-[1px] border-[#D2DAE1] bg-white">
          <VendorSideBar setActiveTab={setActiveTab} activeTab={activeTab} isDisable={isDisable} />
        </div>
        <div className="min-w-0 grow bg-white relative mr-4">{activeVendorComponent()}</div>
      </div>
    </div>
  );
};

export default AddVendor;
